import React from "react";
import formatDate, { formatTime } from "utils/DateUtil";
import "./transaction-item.css";
import { ArrowDownIconV1, ArrowUpIconV1 } from "images/image-component";

interface Props {
  transaction: any;
  /** The list is fetched per-token, so one symbol covers every row. */
  tokenSymbol: string;
  openTransactionDetail: (transaction: any) => void;
}

function TransactionItem({
  transaction,
  tokenSymbol,
  openTransactionDetail,
}: Props) {
  const isIn = transaction.dir === "in";
  const date = new Date(Number(transaction.time) * 1000);
  const rawId: string = transaction.txId ?? "";
  const shortHash =
    rawId.length > 10 ? `${rawId.slice(0, 6)}…${rawId.slice(-4)}` : rawId;

  return (
    <div className="v1-tx-item" onClick={() => openTransactionDetail(transaction)}>
      <div className={`v1-tx-icon ${isIn ? "in" : "out"}`} aria-hidden="true">
        {isIn ? <ArrowDownIconV1 /> : <ArrowUpIconV1 />}
      </div>

      <div className="v1-tx-meta">
        <div className="v1-tx-name">{isIn ? "Received" : "Sent"}</div>
        <div className="v1-tx-sub">
          <span>
            {formatDate(date)} · {formatTime(date)}
          </span>
          {/* {shortHash && (
            <>
              <span className="v1-tx-dot" />
              <span className="v1-tx-hash">{shortHash}</span>
            </>
          )} */}
        </div>
      </div>

      <div className="v1-tx-amount">
        <div className={`v1-tx-value ${isIn ? "in" : "out"}`}>
          {isIn ? "+" : "−"}
          {transaction.value.toFixed(2)} {tokenSymbol}
        </div>
      </div>
    </div>
  );
}

export default TransactionItem;
